<template>
  <b-container fluid class="media-press">
    <b-row no-gutters>
      <b-col>
        <span class="media-press__title">
          Somos destaque na imprensa
        </span>
        <div>
          <a class="media-press__releases-link" href="https://youtu.be/htmWkci_HH0" target="_blank" rel="noopener noreferrer nofollow">
            <VLazyImage
              class="media-press__releases-globo"
              alt="Quero Bolsa na Globo"
              :src="icons.globo"
              width="34"
              height="33"
            />
          </a>
          <a class="media-press__releases-link" href="https://que.bo/materiafolha" target="_blank" rel="noopener noreferrer nofollow">
            <VLazyImage
              class="media-press__releases-folha"
              alt="Quero Bolsa Folha"
              :src="icons.folha"
              width="80"
              height="23"
            />
          </a>
          <a class="media-press__releases-link" href="https://que.bo/materiaveja" target="_blank" rel="noopener noreferrer nofollow">
            <VLazyImage
              class="media-press__releases-veja"
              alt="Quero Bolsa Veja"
              :src="icons.veja"
              width="66"
              height="31"
            />
          </a>
        </div>
      </b-col>
      <b-col>
        <span class="media-press__title">
          Curta nossos canais
        </span>
        <div>
          <social-links></social-links>
        </div>
      </b-col>
      <b-col>
        <span class="media-press__title">
          Atendimento de excelência
        </span>
        <div>
          <VLazyImage
            id="mediaPressReclameAqui"
            :src="icons.reclameAqui"
            alt="Selo Campeã 2015 Reclame Aqui"
            class="media-press__reclame-aqui"
            width="77"
            height="74"
          />
        </div>
        <no-ssr>
          <b-popover
            target="mediaPressReclameAqui"
            triggers="hover"
            :html="true"
            placement="top"
          >
            <div class="media-press__popover">
              <p>O Quero Bolsa é o campeão de atendimento no Brasil, segundo o prêmio ÉPOCA ReclameAQUI 2017.</p>
            </div>
          </b-popover>
        </no-ssr>
      </b-col>
      <b-col>
        <span class="media-press__title">
          Política Bolsa Garantida
        </span>
        <div id="mediaPressBolsaGarantida" class="media-press__content">
          <font-awesome-icon :icon="['far', 'shield-check']" class="media-press__politica" size='3x' />
          <span class="media-press__label">
            Você na faculdade ou seu <br>
            dinheiro de volta
          </span>
        </div>
        <no-ssr>
          <b-popover
            target="mediaPressBolsaGarantida"
            triggers="hover"
            :html="true"
            placement="top"
          >
            <div class="media-press__popover">
              <p>Se por algum motivo você não utilizar a nossa bolsa de estudos, devolveremos o valor pago ao Quero Bolsa.</p>
              <p>Basta entrar em contato conosco em até 6 meses após o pagamento, informando seus dados e o motivo da devolução.</p>
              <p>
                <strong>
                  Fique tranquilo: no Quero Bolsa, nós colocamos sua satisfação em primeiro lugar e vamos honrar nosso compromisso.
                </strong>
              </p>
            </div>
          </b-popover>
        </no-ssr>
      </b-col>
    </b-row>
  </b-container>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'

  .media-press
    padding: 36px 0px

  .media-press__title
    color: $footer-color
    display: inline-block
    font-size: rem(14)
    font-weight: bold
    margin-bottom: 36px

  .media-press__content
    align-items: center
    color: $footer-color
    display: flex

  .media-press__releases-link
    display: inline-block

  .media-press__releases-globo
    height: 33px

  .media-press__releases-folha
    height: 23px
    margin-left: 17px

  .media-press__releases-veja
    height: 31px
    margin: 3px 0 0 7px

  .media-press__reclame-aqui
    margin-top: -$space-m

  .media-press__politica
    height: 52px

  .media-press__label
    display: inline-block
    font-size: rem(13)
    line-height: 1
    margin-left: $space-m
    position: relative
    top: $space-xs

  .media-press__popover
    color: $gray
    font-size: rem(14)
    line-height: 1.2
    max-width: 276px
    padding: 12px $space-xs $space-xxs $space-s

</style>

<script>
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons';
  import VLazyImage from "v-lazy-image";
  import SocialLinks from '~/components/footer/social-links';

  import globo from '~/assets/images/icons/brands/globo.svg';
  import veja from '~/assets/images/icons/brands/veja.svg';
  import folha from '~/assets/images/icons/brands/folha.svg';
  import reclameAqui from '~/assets/images/premio_reclameaqui.svg';

  library.add(faShieldCheck);

  export default {
    data() {
      return {}
    },
    components: {
      FontAwesomeIcon,
      SocialLinks,
      VLazyImage,
    },
    data() {
      return {
        icons: {
          globo,
          veja,
          folha,
          reclameAqui,
        },
      };
    },
  };
</script>
